document.addEventListener('DOMContentLoaded', function() {
    var searchContainer = document.querySelector('.search-container');
    var quickLinks = document.querySelector('.quick-links.right-side');
    var closeIcon = document.querySelector('.search-container .close-icon');
    var searchInput = document.querySelector('#searchbar__searchBox__input');
    var searchLink = document.querySelector('#search-link');
    var FOCUSABLE_SELECTOR = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    var FOCUS_RESTORE_DELAY = 40;

    function addActivationListeners(target, handler) {
        if (!target) {
            return;
        }

        target.addEventListener('click', handler);
        target.addEventListener('keydown', function(event) {
            var key = event.key || event.keyCode;
            var isEnter = key === 'Enter' || key === 13;
            var isSpace = key === ' ' || key === 'Spacebar' || key === 32;

            if (!isEnter && !isSpace) {
                return;
            }

            event.preventDefault();
            handler.call(target, event);
        });
    }

    function isElementHidden(element) {
        var current = element;
        while (current && current !== document.body) {
            if (current.nodeType !== 1) {
                current = current.parentElement;
                continue;
            }

            var styles = window.getComputedStyle(current);
            if (styles.display === 'none' || styles.visibility === 'hidden') {
                return true;
            }

            current = current.parentElement;
        }

        return false;
    }

    function getFocusableElements(container) {
        if (!container) {
            return [];
        }

        return container.querySelectorAll(FOCUSABLE_SELECTOR);
    }

    function getFirstVisibleQuickLink() {
        if (!quickLinks) {
            return null;
        }

        var focusable = getFocusableElements(quickLinks);
        for (var i = 0; i < focusable.length; i++) {
            var candidate = focusable[i];
            if (candidate.hasAttribute('disabled')) {
                continue;
            }

            if (isElementHidden(candidate)) {
                continue;
            }

            return candidate;
        }

        return null;
    }

    function getVisibleFocusableOutsideSearch(startElement) {
        var focusable = Array.prototype.slice.call(document.querySelectorAll(FOCUSABLE_SELECTOR));
        var startIndex = focusable.indexOf(startElement);

        if (startIndex === -1 && searchContainer) {
            startIndex = focusable.indexOf(searchContainer);
        }

        for (var i = startIndex + 1; i < focusable.length; i++) {
            var candidate = focusable[i];

            if (searchContainer && searchContainer.contains(candidate)) {
                continue;
            }

            if (candidate.hasAttribute('disabled')) {
                continue;
            }

            if (isElementHidden(candidate)) {
                continue;
            }

            return candidate;
        }

        return getFirstVisibleQuickLink();
    }

    function hideQuickLinks() {
        if (quickLinks) {
            _classList(quickLinks, 'd-none', 'add');
        }
    }

    function showQuickLinks() {
        if (quickLinks) {
            _classList(quickLinks, 'd-none', 'remove');
        }
    }

    function focusNextVisibleElement(startElement, desiredTarget) {
        setTimeout(function() {
            if (desiredTarget && document.contains(desiredTarget) && !isElementHidden(desiredTarget)) {
                desiredTarget.focus();
                return;
            }

            var fallback = getVisibleFocusableOutsideSearch(startElement || searchContainer);
            if (fallback && document.contains(fallback)) {
                fallback.focus();
            }
        }, FOCUS_RESTORE_DELAY);
    }

    function openSearchContainer() {
        if (!searchContainer) {
            return;
        }

        if (!searchContainer.classList.contains('open')) {
            searchContainer.classList.add('open');
            hideQuickLinks();
        }
    }

    function closeSearchContainer() {
        if (!searchContainer) {
            return;
        }

        if (searchContainer.classList.contains('open')) {
            searchContainer.classList.remove('open');
            fishersci.components.typeahead.showTypeahead(false);
        }

        showQuickLinks();
    }

    function toggleSearchContainer() {
        if (!searchContainer) {
            return;
        }
        if (searchContainer.classList.contains('open')) {
            closeSearchContainer();
        } else {
            openSearchContainer();
            //Set Focus to search input when search container is opened via search link in header
            setTimeout(function() {
                if (closeIcon && document.contains(closeIcon)) {
                    closeIcon.focus();
                }
            }, FOCUS_RESTORE_DELAY);
        }
    }

    function handleSearchContainerFocusOut(event) {
        if (!searchContainer || !searchContainer.classList.contains('open')) {
            return;
        }

        var previousElement = event.target;

        setTimeout(function() {
            var nextTarget = document.activeElement;

            if (nextTarget && searchContainer.contains(nextTarget)) {
                return;
            }

            closeSearchContainer();

            if (!nextTarget || isElementHidden(nextTarget)) {
                focusNextVisibleElement(previousElement, nextTarget);
            }
        }, 0);
    }

    function getSearchContainerFocusableElements() {
        if (!searchContainer) {
            return [];
        }

        return searchContainer.querySelectorAll(FOCUSABLE_SELECTOR);
    }

    function handleSearchContainerKeydown(event) {
        if (!searchContainer || !searchContainer.classList.contains('open')) {
            return;
        }

        if (event.key !== 'Tab' && event.keyCode !== 9) {
            return;
        }

        var focusable = getSearchContainerFocusableElements();
        if (!focusable.length) {
            return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            closeSearchContainer();
            focusNextVisibleElement(last);
            return;
        }

        if (event.shiftKey && document.activeElement === first) {
            closeSearchContainer();
            focusNextVisibleElement(first, getVisibleFocusableOutsideSearch(first));
        }
    }

    if (searchInput) {
        searchInput.addEventListener('click', openSearchContainer);
        searchInput.addEventListener('focus', openSearchContainer);
        searchInput.addEventListener('keydown', handleSearchContainerKeydown);
    }

    if (searchLink) {
        addActivationListeners(searchLink, toggleSearchContainer);
    }

    if (closeIcon) {
        addActivationListeners(closeIcon, closeSearchContainer);
    }

    if (searchContainer) {
        searchContainer.addEventListener('focusout', handleSearchContainerFocusOut, true);
        searchContainer.addEventListener('keydown', handleSearchContainerKeydown);
    }

    var _classList = function(el, className, action){
        if (el.classList) {
            switch(action){
                case 'add':
                    el.classList.add(className);
                    break;
                case 'remove':
                    el.classList.remove(className);
                    break;
                default:
                    el.classList.add(className);
                    break;
            }
        } else {
            switch(action){
                case 'add':
                    el.className += ' ' + className;
                    break;
                case 'remove':
                    var classNames = el.className.split(' ');
                    var index = classNames.indexOf(className);
                    if (index !== -1) {
                        classNames.splice(index, 1);
                        el.className = classNames.join(' ');
                    }
                    break;
                default:
                    el.className += ' ' + className;
                    break;
            }
        }
    }
});